<template>
  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.67 20.61">
    <defs>
    </defs>
    <g id="Layer_2-2" data-name="Layer 2">
      <g>
        <path class="cls-1" d="M7.83,1.58l.79-.79-.79-.79-.79,.79,.79,.79Zm-1.12,13.43c0,.62,.5,1.12,1.12,1.12s1.12-.5,1.12-1.12h-2.24ZM15.34,7.51L8.62,.79l-1.58,1.58,6.71,6.71,1.58-1.58ZM7.04,.79L.33,7.51l1.58,1.58L8.62,2.37l-1.58-1.58Zm-.33,.79V15.01h2.24V1.58h-2.24Z"/>
        <rect class="cls-1" y="18.37" width="15.67" height="2.24"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="css" scoped>
svg {
  height: 18px;
}  

.cls-1 {
  fill: #fff;
}
</style>
